// extracted by mini-css-extract-plugin
export default {"motivateBanner":"bcLs5","rowsSpacing":"MpUwm","title":"iKLqp","textBlock":"QlVCX","text":"GgBbR"};